namespace GeniuzPOS.Purchase {
    export class PoPurInvoiceDtColumns {
        static columnsKey = 'Purchase.PoPurInvoiceDt';
    }
}
